import { motion } from "framer-motion";
import { ReactNode } from "react";

type DropdownFramerProps = {
  children: ReactNode; // Optional children prop
  isDropdownVisible: boolean;
  className?: string;
  nestedDropdown?: boolean;
};

export default function DropdownFramer({
  children,
  isDropdownVisible,
  className,
  nestedDropdown = false
}: DropdownFramerProps) {
  return (
    <motion.div
      className={className}
      animate={{ rotate: isDropdownVisible && !nestedDropdown ? 180 : (nestedDropdown && isDropdownVisible) ? -90 : 0 }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.div>
  );
}
